import { render, staticRenderFns } from "./teacherDialog.vue?vue&type=template&id=09d5b85b&scoped=true&"
import script from "./teacherDialog.vue?vue&type=script&lang=js&"
export * from "./teacherDialog.vue?vue&type=script&lang=js&"
import style0 from "./teacherDialog.vue?vue&type=style&index=0&id=09d5b85b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09d5b85b",
  null
  
)

export default component.exports